/**
 * useWithdrawOptions Hook
 * 협력사/라이더 옵션 목록 조회 전용 훅
 */
import { useCallback, useState } from 'react';
import { headWithdrawApi } from '../api/headWithdrawApi';
import { supplierApi } from '@/features/partner/supplierStatus/api/supplierApi';

/** 협력사 옵션 타입 */
export type SupplierOption = {
    id: string;
    name: string;
    suppType?: string; // F: 가맹, D: 직영
};

/** 라이더 옵션 타입 */
export type RiderOption = {
    id: string;
    name: string;
};

export const useWithdrawOptions = () => {
    const [supplierOptions, setSupplierOptions] = useState<SupplierOption[]>([]);
    const [riderOptions, setRiderOptions] = useState<RiderOption[]>([]);

    const fetchSupplierOptions = useCallback(async (fromDate: string, toDate: string) => {
        try {
            const supplierNames = await headWithdrawApi.getSupplierOptions(fromDate, toDate);
            const supplierDetails = await supplierApi.getSupplierDetailList();

            const suppTypeMap = new Map<string, string>();
            supplierDetails.suppliers.forEach(supplier => {
                suppTypeMap.set(supplier.suppName, supplier.suppType || 'D');
            });

            const optionsWithSuppType: SupplierOption[] = (supplierNames || []).map(item => ({
                id: item.id,
                name: item.name,
                suppType: suppTypeMap.get(item.name) || 'D'
            }));

            setSupplierOptions(optionsWithSuppType);
        } catch {
            setSupplierOptions([]);
        }
    }, []);

    const fetchRiderOptions = useCallback(async (fromDate: string, toDate: string, supplierName?: string) => {
        if (!fromDate || !toDate) {
            setRiderOptions([]);
            return;
        }

        try {
            const response = await headWithdrawApi.getRiderOptions(fromDate, toDate, supplierName || '');
            setRiderOptions(response || []);
        } catch {
            setRiderOptions([]);
        }
    }, []);

    return {
        supplierOptions,
        riderOptions,
        fetchSupplierOptions,
        fetchRiderOptions,
    };
};
